var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.231,
    height: 118,
    viewBox: "0 0 136.231 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us",
    "data-name": "contact us",
    transform: "translate(-101.637 -64.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197129",
    "data-name": "Path 197129",
    d: "M251.229,255.358c15.553-7.075,30.259-17.462,44.337-25.629a1.583,1.583,0,0,0,.786-1.335c.033-1.758.641.032-44.3-29.236a1.579,1.579,0,0,0-2.428,1.137c-2.1,17.635-.992,36.063-.633,53.657a1.58,1.58,0,0,0,2.232,1.4Z",
    transform: "translate(-106.499 -97.268)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197130",
    "data-name": "Path 197130",
    d: "M522.663,77.257a1.58,1.58,0,0,0,2.088-.787,66.52,66.52,0,0,1,5.035-9.15,1.578,1.578,0,1,0-2.637-1.735,69.732,69.732,0,0,0-5.275,9.584,1.58,1.58,0,0,0,.789,2.088Z",
    transform: "translate(-304.881)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197131",
    "data-name": "Path 197131",
    d: "M544.42,100.552a1.578,1.578,0,0,0,2.219.235,49.707,49.707,0,0,1,8.3-5.438,1.578,1.578,0,1,0-1.457-2.8,52.922,52.922,0,0,0-8.833,5.786,1.577,1.577,0,0,0-.234,2.218Z",
    transform: "translate(-321.089 -19.954)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197132",
    "data-name": "Path 197132",
    d: "M555.213,141.041a1.58,1.58,0,0,0,1.183,1.893l8.688,2a1.578,1.578,0,1,0,.708-3.076l-8.686-2a1.584,1.584,0,0,0-1.892,1.183Z",
    transform: "translate(-329.147 -54.391)",
    fill: "#f82121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197133",
    "data-name": "Path 197133",
    d: "M103.593,209.994a7.207,7.207,0,0,0,7.182,7.374l103.071.294a7.194,7.194,0,0,0,6.569-4.174,1.563,1.563,0,0,0,.523-1.123c.757-31.592.94-64.378,1.024-95.1a1.579,1.579,0,0,0-1.459-1.578c-47.373-3.585-55.305-3.29-88.837-1.958-28.191,1.116-26.194.486-26.968,1.279a1.582,1.582,0,0,0-.446,1.106c-1.006,1.36-2.843,3.229-2.594,6.448,2.249,28.924,2.553,58.382,1.934,87.432ZM218.8,118.725c-.086,29.774-.268,61.429-.983,92.01-11.027-.093-22.785.035-34.17.16-59.345.649-45.7-.76-74.643-.973,1.817-31.815-1.067-60.341-1.578-92.254,47.634-.719,43.221-4.05,111.375,1.056Z",
    transform: "translate(0 -34.787)",
    fill: "#f82121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.7621c1abe291a7cc84dee714f4157964.svg";
export { ForwardRef as ReactComponent };